export default function ProductName({ productName }) {
  return <>{productName}</>
}
